module.exports = __webpack_public_path__ + "img/Stem-jobs.9b64f44b.webp";